export function filterSentryErrors<T extends { environment?: string }>(
  event: T
) {
  return event.environment === 'stage' || event.environment === 'production'
    ? event
    : null;
}
